<template>
  <footer class="footer">
    <div class="flex-wrapper">
      <ul class="list list--links">
        <li class="list__item">
          <a class="link" :href="$t('meta.privacy.url')" target="_blank">{{ $t('meta.privacy.label') }}</a>
        </li>
        <li class="list__item">
          <a class="link" :href="$t('meta.imprint.url')" target="_blank">{{ $t('meta.imprint.label') }}</a>
        </li>
        <li class="list__item">
          <router-link tag="a" class="link" exact :to="{ name: 'FAQ', params: { language: $route.params.language } }" target="_blank">
            {{ $t('meta.faq.label') }}
          </router-link>
        </li>
      </ul>
      <ul class="list list--images">
        <li class="list__item" v-for="(payment, index) in paymentBrands" :key="index">
          <img class="image" :title="payment" :alt="payment" :src="`/../../assets/img/payment_${payment}.svg`" />
        </li>
      </ul>
    </div>
    <div class="legal">
      <p>
        {{ $t('meta.legal.address') }} |
        {{ $t('meta.legal.registrationNumber') }}: HRB 235860
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CiFooter',
  props: {
    campground: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentBrands: ['VISA', 'MASTER', 'SOFORTUEBERWEISUNG', 'IDEAL', 'AMEX'],
    }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  padding: 30px 0 120px;

  @include media-breakpoint-up(md) {
    padding: 30px 0 80px;
  }

  @include media-breakpoint-up(lg) {
    padding: 30px 0;
  }
}

.flex-wrapper {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: auto;

  @include media-breakpoint-up(md) {
    flex-direction: row;
  }

  @include media-breakpoint-up(lg) {
    flex-direction: row;
  }
}

.legal {
  text-align: right;
  font-size: 0.7rem;
  @include media-breakpoint-up(md) {
    padding-top: 20px;
  }
}

.list {
  list-style: none;
  margin: 0 0 10px;
  padding: 0;

  .list__item {
    display: inline;
    margin: 0;
    padding: 0;
  }

  &.list--links {
    .link {
      @include font('gotham_bookregular');
      @include font-format(0.75rem, 0.875rem);

      color: inherit;

      &:active,
      &:visited,
      &:focus {
        color: inherit;
      }
    }

    .list__item {
      &::after {
        @include font('gotham_bookregular');
        @include font-format(0.75rem, 0.875rem);

        content: '|';
        padding: 0 5px;
      }
      &:last-child {
        &::after {
          content: '';
        }
      }
    }
  }

  &.list--images {
    margin: 10px 0;

    @include media-breakpoint-up(md) {
      margin: 0;
    }

    .image {
      filter: grayscale(100%);
      height: 15px;
      margin: 0 10px 20px;
      width: auto;
      transition: filter 1s ease;

      .no-touch &:hover {
        filter: grayscale(0);
        transition: filter 0.2s ease;
      }

      @include media-breakpoint-up(md) {
        margin: 0 10px;
      }

      @include media-breakpoint-up(lg) {
        height: 20px;
      }
    }

    .list__item:first-child {
      .image {
        margin-left: 0;
      }
    }
  }
}
</style>
